export default "__VITE_ASSET__25acc223__"